import React from "react";
import { Activity, Move3d, HeartPulse, Users, ShieldCheck, Stethoscope, ArrowUpRight } from "lucide-react";
import { siteData } from "../mock";

const iconMap = {
  activity: Activity,
  move: Move3d,
  "heart-pulse": HeartPulse,
  users: Users,
  shield: ShieldCheck,
  stethoscope: Stethoscope,
};

export default function Specialties() {
  return (
    <section className="container-tight py-24">
      <div className="max-w-2xl mb-14">
        <span className="chip mb-4">Motifs d'accompagnement</span>
        <h2 className="font-serif text-4xl md:text-5xl font-medium text-[#1a1815] tracking-tight leading-[1.05]">
          Mes spécialités
        </h2>
        <p className="mt-4 text-[#4a4642] text-lg">
          Un accompagnement personnalisé pour retrouver mobilité, apaiser vos douleurs et reprendre confiance dans votre corps.
        </p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {siteData.specialties.map((s, i) => {
          const Icon = iconMap[s.icon] || Activity;
          return (
            <div
              key={s.title}
              className="group relative bg-white rounded-3xl p-7 border border-[#e8e0d5] hover:border-[#d97757]/40 hover:shadow-xl hover:shadow-[#1a1815]/5 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 rounded-2xl bg-[#f7f2ec] group-hover:bg-[#d97757] flex items-center justify-center transition-colors mb-5">
                <Icon size={22} className="text-[#d97757] group-hover:text-white transition-colors" />
              </div>
              <h3 className="font-serif text-xl font-medium text-[#1a1815] mb-2">{s.title}</h3>
              <p className="text-[#4a4642] text-sm leading-relaxed">{s.desc}</p>
              <div className="mt-5 flex items-center gap-2 text-sm font-medium text-[#d97757] opacity-0 group-hover:opacity-100 transition-opacity">
                En savoir plus <ArrowUpRight size={16} />
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
